import { render, staticRenderFns } from "./info-window.vue?vue&type=template&id=15958383&"
import script from "./info-window.vue?vue&type=script&lang=js&"
export * from "./info-window.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// /home/forge/bpbauto.stagingwebsite.dev/web/app/themes/bpb/node_modules/gmap-vue/dist/components/info-window.vue
// module id = 110
// module chunks = 0